module.exports = __webpack_public_path__ + "img/mutual-formula.4d544411.png";